import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../core/client';
import { growRoomRackLevelKeys } from '../../core/query-keys';
import { growRoomRackLevelEndpoints } from './grow-room-rack-levels.endpoints';
import type {
  GrowRoomRackLevel,
  CreateGrowRoomRackLevelRequest,
  UpdateGrowRoomRackLevelRequest,
} from './grow-room-rack-levels.types';

export function useGrowRoomRackLevels() {
  return useQuery({
    queryKey: growRoomRackLevelKeys.list,
    queryFn: async () =>
      (
        await api.get<{ grow_room_rack_levels: GrowRoomRackLevel[]; next_page_token: string }>(
          growRoomRackLevelEndpoints.list,
        )
      ).grow_room_rack_levels ?? [],
  });
}

export function useCreateGrowRoomRackLevel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: CreateGrowRoomRackLevelRequest) =>
      api.post<GrowRoomRackLevel>(growRoomRackLevelEndpoints.list, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: growRoomRackLevelKeys.all }),
  });
}

export function useUpdateGrowRoomRackLevel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...req }: UpdateGrowRoomRackLevelRequest & { id: string }) =>
      api.patch<GrowRoomRackLevel>(growRoomRackLevelEndpoints.one(id), req),
    onSuccess: () => qc.invalidateQueries({ queryKey: growRoomRackLevelKeys.all }),
  });
}

export function useDeleteGrowRoomRackLevel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<void>(growRoomRackLevelEndpoints.one(id)),
    onSuccess: () => qc.invalidateQueries({ queryKey: growRoomRackLevelKeys.all }),
  });
}
